
<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="800px" transition="dialog-transition">
      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <div class="headline mb-0">Lista de comissões</div>
        </v-card-title>
        <v-card-text>
          <list-comission :is_employee="is_employee" :is_product="is_product" :editing="editing" :main_data.sync="main_data"></list-comission>
        </v-card-text>
        <v-card-actions class="justify-end">
          <f-btn @click="$route.name == 'EditProductComission' ? $router.go(-1) : closeDialog()" cancel></f-btn>
          <f-btn :disabled="!user_allowed" @click="submitComissions() /*dar update no employee*/" save></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-if="loading" v-model="loading" persistent max-width="800px" transition="dialog-transition">
      <v-alert type="info" :value="true">
        <div>
          Atualizando...
        </div>
        <div>
          <v-progress-linear color="white" :indeterminate="true"></v-progress-linear>
        </div>
      </v-alert>
    </v-dialog>


  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api/index';

export default {
  name: 'DialogListComission',
  components: {
    ListComission: () => import('./ListComission.vue'),
  },
  props: {
    main_data: {
      type: Object,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    is_employee: {
      type: Boolean,
      default: true
    },
    is_product: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      dialog: true,
      loading: false,
    }
  },
  methods: {
    closeDialog() {
      if (this.main_data.comissions_attributes.length) {
        this.swallConfirmation({
          title: 'Você possui alterações. Deseja fechar sem salvar?',
          icon: 'question',
        }).then( confirmed =>{
          if (confirmed ) {
            this.dialog = false
          }
        })        
      } else {
        this.dialog = false
      }
    },
    submitComissions() {
      if (this.main_data.comissions_attributes.length) {
        this.swallConfirmation({
          title: 'Salvar comissões do vendedor?',
          icon: 'question',
        }).then( confirmed =>{
          if (confirmed ) {
            let obj = {
              id: this.main_data.id,
              comissions_attributes: this.main_data.comissions_attributes,
            }
            this.loading = true
            if (this.is_employee) {
              Api.Employee.updateInfo(obj, obj.id).then(r => {
                this.dialog = false
                this.addNotification({type: 'success',  msg: `Atualizado com sucesso!.`})
              }).catch(err => {
                this.addNotification({type: 'error',  msg: `${err}`})
              }).finally(()=>{
                this.loading = false
              })
            } else if (this.is_product) {
              this.updateProduct({ id: obj.id, product: obj }).then(r => {
                this.loading = false
                this.dialog = false
                this.addNotification({type: 'success',  msg: `Atualizado com sucesso!.`})
              }).catch(err => {
                this.loading = false
                this.addNotification({type: 'error',  msg: `${err}`})
              })
            }
          }
        })

      } else {
        this.dialog = false
      }
    },
    ...mapActions({
      
      updateProduct: 'Supplier/updateOnlyProduct',
    })
  },
  computed: {
    user_allowed() {
      return ['Manager', 'Director'].includes(this.profile?.included[0]?.attributes?.role?.data[0]?.attributes?.name)
    },
    ...mapState({
      profile: state => state.User.oneUser,
    })
  },
  watch: {
    dialog(nv, ov) {
      if (nv) {
      } else if (nv == false) {
        this.$emit('close')
      }
    }
  },
}
</script>

<style scoped>

</style>
